export default __webpack_public_path__ + "static/media/ImperialLogo.a3b4a0c1.png";